<template>
  <div class="newPapers">

    <div class="tianjia">
      <el-button type="success" @click="insertArticle">{{$t('messages.添加文章')}}</el-button>
    </div>

    <!--数据展示-->
    <el-table :data="tableData"
              stripe
              style="width: 100%"
              border
              highlight-current-row
              :header-cell-style="{'text-align':'center'}"
              @row-dblclick="rowDbclick"
    >
      <el-table-column type="index" :label="$t('messages.序号')" min-width="3.1" align='center' class="index"/>
      <el-table-column prop="year" :label="$t('messages.发布年份')" sortable min-width="5.5" align='center' class="year"/>
      <el-table-column prop="title" :label="$t('messages.题目')" min-width="28"/>
      <el-table-column prop="author" :label="$t('messages.作者')" min-width="22.8"/>
      <el-table-column prop="journal" :label="$t('messages.期刊')" min-width="18"/>
      <!--<el-table-column prop="influFactor" :label="$t('messages.影响因子')" sortable min-width="6" align='center' class="influFactor"/>
      <el-table-column prop="partition" :label="$t('messages.分区')" min-width="5" align='center' class="partition"/>
      <el-table-column prop="link" :label="$t('messages.链接')" min-width="3.6">
        <template #default="scope">
          <el-link v-if="scope.row.link != ''" :underline="false" icon="link" :href="scope.row.link"></el-link>
        </template>
      </el-table-column>-->
      <el-table-column min-width="8">
        <template #header>{{$t('messages.操作')}}</template>
        <template #default="scope">
          <el-button size="small" type="success" @click="handleEdit(scope.$index, scope.row)">Edit</el-button>
          <el-button size="small" type="danger" @click="handleDelete(scope.$index, scope.row)">Del</el-button>
        </template>
      </el-table-column>
    </el-table>

    <!--编辑-->
    <el-dialog v-model="dialogVisible" :title="$t('messages.文章信息')" @close="dialogClose">
      <el-form ref="formRef" :model="formData" :rules="formRules">
        <el-form-item :label="$t('messages.年份')" prop="year" label-width="80px">
          <el-input v-model="formData.year" autocomplete="off" />
        </el-form-item>
        <el-form-item :label="$t('messages.题目')" prop="title" label-width="80px">
          <el-input v-model="formData.title" autocomplete="off" />
        </el-form-item>
        <el-form-item :label="$t('messages.作者')" prop="author" label-width="80px">
          <el-input v-model="formData.author" autocomplete="off" />
        </el-form-item>
        <el-form-item :label="$t('messages.期刊')" prop="journal" label-width="80px">
          <el-input v-model="formData.journal" autocomplete="off" />
        </el-form-item>
        <el-form-item :label="$t('messages.类型')" label-width="80px">
          <el-radio v-model="radio" label="1" size="large">{{$t('messages.英文文献')}}</el-radio>
          <el-radio v-model="radio" label="0" size="large">{{$t('messages.中文文献')}}</el-radio>
        </el-form-item>
        <el-form-item :label="$t('messages.文件')" prop="link" label-width="80px" v-if="flag === true">
          <el-input v-model="formData.link" autocomplete="off" disabled/>
        </el-form-item>
        <el-form-item prop="file" label-width="80px">
          <upload-file ref="update" class="update" @uploadSuccess="uploadSuccess" :uploadURL="flag === true ? modifyURL : insertURL"></upload-file>
        </el-form-item>
        <!--<el-form-item :label="$t('messages.影响因子')" prop="influFactor" label-width="80px">
          <el-input v-model="formData.influFactor" autocomplete="off" />
        </el-form-item>
        <el-form-item :label="$t('messages.分区')" prop="partition" label-width="80px">
          <el-input v-model="formData.partition" autocomplete="off" />
        </el-form-item>
        <el-form-item :label="$t('messages.链接')" prop="link" label-width="80px">
          <el-input v-model="formData.link" autocomplete="off" />
        </el-form-item>-->
      </el-form>
      <template #footer>
        <span class="dialog-footer">
          <el-button type="primary" @click="submitModify">{{$t('messages.确认')}}</el-button>
          <el-button  @click="cancelModify">{{$t('messages.取消')}}</el-button>
        </span>
      </template>
    </el-dialog>


    <!--分页-->
    <el-pagination
            :currentPage="pagination.currentPage"
            :page-size="pagination.pageSize"
            :total="pagination.total"
            :page-sizes="[10, 20, 50, 100, 200, 500]"
            background
            layout="total, sizes, prev, pager, next, jumper"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
    />

    <Animate ref="animate" />
  </div>
</template>

<script>

  import {ref, reactive, onMounted, getCurrentInstance} from 'vue';
  import { useI18n } from 'vue-i18n'//要在js中使用国际化
  import {useStore, mapGetters} from 'vuex'
  import {useRoute, useRouter} from 'vue-router';
  import {queryArticle} from '@/network/article'
  import Animate from "@/components/common/Animate";
  import UploadFile from "@/views/admin/childComps/UploadFile";

  import {Link} from '@element-plus/icons-vue'
  import {ElMessage, ElMessageBox} from 'element-plus'
  import { modifyArticle, deleteArticle, insert } from "@/network/article";



  export default {
    name: "NewPapers",
    components:{
      Animate,
      UploadFile,
    },
    computed: {
      ...mapGetters(['showUploadFile'])
    },//computed
    setup() {

      let store = useStore();
      const router = useRouter()
      let instance = reactive({});
      instance = getCurrentInstance();
      //const { proxy } = getCurrentInstance();
      // t 引用i18n
      const { t } = useI18n()
      //分页数据
      let pagination = reactive({
        currentPage: 1,
        pageSize: 20,
        total: 0,
      })
      // header
      let headers = reactive({
        'token': localStorage.getItem('token'),
      });
      let fileLength = 0;
      let insertURL = ref(store.state.uploadAddr + '/article/insert')
      let modifyURL = ref(store.state.uploadAddr + '/article/modifyArticle')

      //论文数据
      let pagerData = reactive([]);
      //表格数据
      let tableData = reactive([]);
      //是否显示dialog
      let dialogVisible = ref(false)
      //dialog表单数据
      let formData = reactive({
        year: '',
        title: '',
        author: '',
        journal: '',
        link: '',
      });
      let radio = ref('1');
      //校验规则
      let formRules = reactive({
        title: [{ required: true, message: t('messages.文章标题不能为空'), trigger: 'blur' }],
        author: [{ required: true, message: t('messages.作者名不能为空'), trigger: 'blur' }],
      });
      // flag为真发送修改请求, 为假发送新增文章请求, 默认为真
      let flag = ref(true);


      queryArticle().then(res => {
        if (res.state === 200) {
          pagination.total = res.data.length;
          res.data.forEach(item => pagerData.push(item))
          //console.log('data:', pagerData[0])
          changeTableData(pagination.pageSize, pagination.currentPage);
        } else if (res.state === '50000'){
          router.push('/regLogin');
          ElMessage.error(t('regLogin.您的登录信息已过期, 请重新登录'));
        }
      })

      onMounted(() => {
        let timer = setTimeout(function () {
          instance.proxy.$refs.animate.isShow = false
          clearTimeout(timer)
        }, 100)
      })


      // methods
      // 页面尺寸改变
      function handleSizeChange(newSize) {
        //console.log("页面尺寸改变了", newSize)
        //console.log(pagerData.length);
        pagination.pageSize = newSize;
        tableData.length = 0;
        changeTableData(newSize, pagination.currentPage)
      }

      // 页码变化
      function handleCurrentChange(newPage) {
        //console.log("页码发生变化", newPage)
        pagination.currentPage = newPage;
        tableData.length = 0;
        changeTableData(pagination.pageSize, newPage)
      }

      // 修改tableData的方法
      function changeTableData(newSize, newPage) {
        let from = (newPage - 1) * newSize;
        let to = 0;
        if ((from + newSize) < pagination.total) to = from + newSize;
        else to = pagination.total;
        for (let i = from; i < to; i++) {
          tableData.push(pagerData[i])
        }
      }

      //uploadSuccess
      function uploadSuccess(){
        //console.log('上传成功')
      }
      // 修改事件
      let articleId = 0;
      function handleEdit(index, row) {
        dialogVisible.value = true;
        articleId = tableData[index].id;
        formData.year = row.year;
        formData.title = row.title;
        formData.author = row.author;
        formData.journal = row.journal;
        formData.influFactor = row.influFactor;
        formData.partition = row.partition;
        formData.link = row.link;
        radio.value = row.partition;
      }
      // 发送修改请求
      async function submitModify() {
        //dialogVisible.value = true;
        console.log('flag.value: ', flag.value)
        if (flag.value === true){
          if (instance.proxy.$refs.update.fileList.length !== 0) fileLength = 1
          modifyArticle(articleId, formData.year, formData.title, formData.author, formData.journal, radio.value, localStorage.getItem('username'), fileLength).then(() => {
            console.log('执行修改')
            if (fileLength === 1){
              instance.proxy.$refs.update.submitUpload();
              instance.proxy.$refs.update.clearFile();
            }
            dialogVisible.value = false;
            fileLength = 0;
            /*if (res.state === 200)
              ElMessage.success(t('messages.修改成功'));
            else if (res.state === '50000'){
              router.push('/regLogin');
              ElMessage.error(t('regLogin.您的登录信息已过期, 请重新登录'));
            } else ElMessage.error(t('messages.修改失败'));*/
          })
          instance.proxy.$refs.formRef.resetFields();
        }
        else{ //新增请求
          if (instance.proxy.$refs.update.fileList.length !== 0) fileLength = 1
          await insert(formData.year, formData.title, formData.author, formData.journal, radio.value, localStorage.getItem('username'), fileLength).then(() => {
            console.log('执行新增')
            if (fileLength === 1){
              instance.proxy.$refs.update.submitUpload();
              instance.proxy.$refs.update.clearFile();
            }
            dialogVisible.value = false;
            fileLength = 0;
            /*if (res.state === 200)
              ElMessage.success(t('messages.添加成功'));
            else if (res.state === '50000'){
              router.push('/regLogin');
              ElMessage.error(t('regLogin.您的登录信息已过期, 请重新登录'));
            } else ElMessage.error(t('messages.添加失败'));*/
          })
          flag.value = true
        }
        instance.proxy.$refs.formRef.resetFields();
      }
      // 删除事件
      function handleDelete(index, row) {
        ElMessageBox.confirm(
            t('messages.确认删除?'),
            'Warning',
            {
              confirmButtonText: t('messages.确认'),
              cancelButtonText: t('messages.取消'),
              type: 'warning',
            }
        ).then(() => {
              articleId = tableData[index].id;
              deleteArticle(articleId).then(res => {
                if (res.state === 200){
                  ElMessage.success(t('messages.删除成功'))
                } else if (res.state === '50000'){
                  router.push('/regLogin');
                  ElMessage.error(t('regLogin.您的登录信息已过期, 请重新登录'));
                } else ElMessage.error(t('messages.删除失败'))
              })
            })
      }
      // dialog关闭事件
      function dialogClose() {
        instance.proxy.$refs.formRef.resetFields();
        radio.value = '1';
      }
      function cancelModify() {
        instance.proxy.$refs.formRef.resetFields();
        dialogVisible.value = false
      }
      // 发送添加请求
      /*function submitInsert() {
        // flag 置为false
        flag.value = false;
        submitModify();
      }*/
      // 点击新增文章按钮
      function insertArticle() {
        dialogVisible.value = true
        //instance.proxy.$refs.formRef.resetFields();
        flag.value = false;
      }
      //双击事件
      function rowDbclick(row, column, event) {
        if (row.link !== '')
          location.href = store.state.uploadFile + row.link
      }


      return {
        tableData, pagination, dialogVisible, formData, formRules, headers, flag, insertURL, modifyURL, radio,
        handleSizeChange, handleCurrentChange,handleEdit,handleDelete,dialogClose, submitModify, insertArticle, rowDbclick, uploadSuccess, cancelModify,
      }
    }
  }
</script>

<style scoped lang="less">

  .tianjia{
    display: flex;
    justify-content: end;
    margin: -32px 20px 30px 0;
  }
  .el-table {
    margin-top: 50px;

    .el-icon:hover {
      color: #409EFF
    }

  }

  .el-pagination{
    display: flex;
    justify-content: center;
    padding: 40px 20px 100px 0;
  }

</style>